import { Controller } from 'stimulus';

export default class FileUploadController extends Controller {
  static targets = ['label', 'input'];

  defaultLabelText = null;

  dragOverChildElementsCounter = 0;

  connect() {
    this.defaultLabelText = this.labelTarget.textContent;
    this.element.addEventListener('dragenter', this.onDragEnter);
    this.element.addEventListener('dragleave', this.onDragLeave);
    this.element.addEventListener('dragover', this.onDragOver);
    this.element.addEventListener('drop', this.onDrop);
  }

  disconnect() {
    this.element.removeEventListener('dragenter', this.onDragEnter);
    this.element.removeEventListener('dragleave', this.onDragLeave);
    this.element.removeEventListener('dragover', this.onDragOver);
    this.element.removeEventListener('drop', this.onDrop);
  }

  setLabelText(text) {
    if (text === this.defaultLabelText) {
      this.labelTarget.classList.remove('filled');
    } else {
      this.labelTarget.classList.add('filled');
    }

    this.labelTarget.textContent = text;
  }

  processFiles(fileList) {
    if (!fileList || !fileList.length) {
      this.setLabelText(this.defaultLabelText);
      return;
    }

    if (this.inputTarget.files !== fileList) {
      this.inputTarget.files = fileList;
    }

    this.setLabelText(fileList[0].name);
  }

  updateLabel(event) {
    this.processFiles(event.target.files);
  }

  selectFile() {
    this.inputTarget.click();
  }

  onDragEnter = () => {
    this.dragOverChildElementsCounter++;
    this.element.classList.add('drag');
  };

  onDragLeave = () => {
    this.dragOverChildElementsCounter--;
    if (!this.dragOverChildElementsCounter) {
      this.element.classList.remove('drag');
    }
  };

  onDragOver = (event) => {
    event.preventDefault();
  };

  onDrop = (event) => {
    event.preventDefault();
    this.processFiles(event.dataTransfer.files);
    this.element.classList.remove('drag');
    this.dragOverChildElementsCounter = 0;
  };
}
